<template>
    <CollapsibleCard title="My posts in the player pool">
        <template v-slot:content>
            <div v-if="loading" class="d-flex align-center justify-center">
                <v-progress-circular size="20" indeterminate color="primary" width="2"></v-progress-circular>
            </div>

            <div v-else-if="posts.length == 0" class="text--disabled">
                {{$translate('You have not made any posts in the player pool yet')}}
            </div>

            <TeamsportPlayerPoolPost v-else
                                     v-for="post in posts" :key="post.id"
                                     :post="post"
                                     type="user"
                                     :showReplyButton="false"
                                     :showEditButton="true"
                                     :teamsports="teamsports"
                                     class="mb-4"
            >
                <template #title>
                    <div class="font-weight-bold">{{ getTitle(post) }}</div>
                </template>
            </TeamsportPlayerPoolPost>
        </template>
    </CollapsibleCard>
</template>

<script>
import CollapsibleCard from '../components/CollapsibleCard.vue'
import TeamsportPlayerPoolPost from './TeamsportPlayerPoolPost.vue'
export default {
    name: 'zoezi-teamsport-player-pool-my-posts',
    props: {
        teamsports: {
            type: Array
        },
        posts: {
            type: Array
        }
    },
    components: {
        CollapsibleCard,
        TeamsportPlayerPoolPost
    },

    data: () => ({
        loading: false
    }),
    methods: {
        getTitle(post) {
            return post.teamsport_ids.map((teamsport_id) => {
                return this.teamsports.find((teamsport) => teamsport.id === teamsport_id)?.name
            }).join(', ')
        }
    }
}
</script>
